// const hostname = window.location.host;
// const prod = ".nfweb.ca";
// const dev = "upick.js.nfweb.ca";
// const domString = (dom) => `https://${dom}`;
// export const DOMAIN = hostname.match(prod) ? domString(hostname) : domString(dev);
export const DOMAIN = `https://${window.location.host}`;
export const API_PATH = "/wp-json/wp/v2/";
